import { AdminApi } from 'stylemix-vue-admin'

export default class CompaniesApi extends AdminApi {
  constructor(parameters) {
    super('companies', parameters)
  }

  sendMail(companyId, data, config = {}) {
    return this.submit(
      'post',
      `/${this.endpoint}/${companyId}/sendmail`,
      data,
      config,
    )
  }

  unsuspend(companyId) {
    return this.submit('post', `/${this.endpoint}/${companyId}/unsuspend`)
  }
}
